/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { ModelsPublicBarbersOutput } from "../../entities/models/PublicBarbersOutput";
import { modelsPublicBarberOutputSchema } from "./publicBarberOutputSchema";
import { z } from "zod/v4";

export const modelsPublicBarbersOutputSchema = z.object({
    get "barbers"(){
                return z.array(modelsPublicBarberOutputSchema).optional()
              }
    }) as unknown as z.ZodType<ModelsPublicBarbersOutput>